import { render } from "./InfoGraphicList.vue?vue&type=template&id=01621a9e&scoped=true&ts=true"
import script from "./InfoGraphicList.ts?vue&type=script&lang=ts"
export * from "./InfoGraphicList.ts?vue&type=script&lang=ts"

import "./InfoGraphicList.scss?vue&type=style&index=0&id=01621a9e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01621a9e"]])

export default __exports__